shadow$provide[489] = function(require,module,exports) {
var require$_DOT__SLASH_block = require("./block");
var require$_DOT__SLASH_call = require("./call");
var require$_DOT__SLASH_callback = require("./callback");
var require$_DOT__SLASH_isolate = require("./isolate");
var require$_DOT__SLASH_join = require("./join");
require.exportCopy(module, require$_DOT__SLASH_block);
require.exportCopy(module, require$_DOT__SLASH_call);
require.exportCopy(module, require$_DOT__SLASH_callback);
require.exportCopy(module, require$_DOT__SLASH_isolate);
require.exportCopy(module, require$_DOT__SLASH_join);

};